import axios from 'axios';
import { GateInGetAllQuery, IdProps } from '../../types';
import { extendContainerValidator, toIsoDate } from '../../utils';

class GateInsService {
  getAll = (props: any) => axios.get<GateInGetAllQuery>(`/gate-ins`, props);

  getAllPreFormatProps = (props: any) => {
    const keys = props.params;

    if (keys.containerNumber?.length < 3 || !extendContainerValidator(keys.containerNumber))
      delete keys.containerNumber;
    if (keys.startDate) keys.startDate = toIsoDate(keys.startDate, true);
    if (keys.endDate) keys.endDate = toIsoDate(keys.endDate, true);

    return axios.get<GateInGetAllQuery>(`/gate-ins`, props);
  };

  get = (id: any) => axios.get(`/gate-ins/${id}`);

  add = (props: any) => axios.post(`/gate-ins`, props);

  complete = async ({ id, props }: any) => axios.patch(`/gate-ins/${id}`, props);

  delete = (props: IdProps[]) => axios.delete('/gate-ins', { data: props });
}

export const gateInsService = new GateInsService();
